const FIELD_SELECTOR = "[data-field-key]";

/**
 * Field keys the viewer can see right now: the field's `data-field-key`
 * wrapper is on the page and its input rendered something. Fields hidden by
 * a radio answer, a collapse checkbox, the viewer's role, `control_basetask`
 * or profit render no wrapper or an empty one, and fields behind a picker
 * carry no key.
 */
export const getFieldKeysOnPage = (container: ParentNode | null): Set<string> =>
  new Set(
    Array.from(container?.querySelectorAll<HTMLElement>(FIELD_SELECTOR) ?? [])
      .filter((element) => element.childElementCount > 0)
      .map(({ dataset }) => dataset.fieldKey ?? "")
      .filter(Boolean)
  );
